import { currency_icon } from "@/constants"

const keyName = 'currency'

export const getCurrency = () => JSON.parse(localStorage.getItem(keyName)) || ''

export const setCurrency = (value) => {
    const currency = getCurrency()
    
    if(!currency || !['azn', 'usd'].includes(currency?.toLowerCase())) {
        localStorage.setItem(keyName, JSON.stringify(value))
    }
}

export const changeCurrency = (value) => {
    if(['azn', 'usd'].includes(value?.toLowerCase())) {
        localStorage.setItem(keyName, JSON.stringify(value))
    }
}

export function convertCurrency(amount,default_currency, currency) {
    const exchangeRates = {
        'AZN': {
            'USD': 1 / 1.7
        },
        'USD': {
            'AZN': 1.7
        }
    };
    if (!(default_currency in exchangeRates) || !(currency in exchangeRates[default_currency])) {
        return `${currency_icon[currency]}${amount}`
    }
    return `${currency_icon[currency]}${(amount * exchangeRates[default_currency][currency]).toFixed(2)}`;
  }